<template>
  <div>
    <!-- {{ formModel }} -->
    <!-- bind:{{ bind }} -->
    <!-- <v-switch :label="title" v-if="!showAll" v-model="showTable"></v-switch> -->
    <!-- option:{{ option }} -->

    <v-radio-list
      :k="data_object.object_name"
      :schema="schema"
      v-if="!showAll"
      v-model="showTable"
      :vModel="showTable"
      :key="rKey"
    ></v-radio-list>

    <d-table
      v-if="tableReady && (showTable == 'existing' || showAll)"
      v-bind="vBind"
      :getFreshData="getFreshData"
      :data_object="data_object"
      :key="tableKey"
      ref="dTable"
    ></d-table>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
export default {
  name: "LinkedObject",
  components: {
    DTable: () => import("./Table.vue"),
    VRadioList: () => import("./RadioList.vue"),
  },
  props: {
    vBind: Object,
    vModel: Boolean,
    formModel: [Object, Array],
    showAll: Boolean,
    getFreshData: Boolean,
    data_object: Object,
    getDefaultProperties: Boolean,
    // showTable: Boolean,
  },
  data() {
    return {
      showTable: "new",
      tableKey: 0,
      selected_id: null,
      tableReady: false,
      title: "",
      schema: {},
      rKey: 0,
      // bind: {
      //   k: "option",
      //   schema: {
      //     option: {
      //       "v-bind": {
      //         items: ["new", "existing"],
      //         capitalizeText: true,
      //         row: true,
      //       },
      //     },
      //   },
      // },
    };
  },
  mounted() {
    // this.data_object = this.vBind.data_object;
    if (this.getDefaultProperties) {
      // this.vBind = this.data_object["v-bind"];
    }
    this.vBind.singleSelect = true;
    this.vBind.noInitEdit = true;
    this.tableReady = true;
    this.title =
      "Find Existing " + fun.capitalize(this.data_object.object_name);
    // this.k=this.data_object.object_name
    this.schema[this.data_object.object_name] = {
      "v-bind": {
        items: ["new", "existing"],
        // { text: "new", value: 0 },
        // { text: "existing", value: 1 },

        capitalizeText: true,
        row: true,
      },
    };
    this.rKey = !this.rKey;
    // axios
    //   .post(this.serverURL + "/get_data", this.data_object, {
    //     withCredentials: true,
    //   })
    //   .then((response) => {
    //     console.log(response);
    //   });

    // this.data_object = {
    //   object_name: this.object_name,
    //   title: this.title,
    //   all_records: true,
    //   hasSearch: true,
    // };
  },
  beforeDestroy() {},
  methods: {
    rowClick(r) {
      // console.log(r);
      var object_name = this.data_object.object_name;
      var table = this.$refs.dTable;
      this.$root.$emit("linkedObjectSelected", {
        objectName: object_name,
        data: r,
        tbl: table,
      });
      this.formModel[object_name] = r;
      // this.$emit("input", r);
    },
  },
  watch: {
    showTable: function() {
      if (this.showTable == "existing") {
        this.$emit("input", false);
      } else {
        this.$emit("input", true);
      }
    },
  },
};
</script>

<style lang="css" scoped></style>
